import * as React from 'react';
import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MediaProps, MediaType } from '../media-constant';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import { DEFI, EX, IMG, LEFT, PRONOUNCE, RIGHT, RIGHT1, WORD } from './type';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';

const VocabNodeReadOnly = dynamicEditorComponent(
  () =>
    import(/* webpackExports: "VocabNodeReadOnly" */ './VocabCardNode').then(
      (mod) => mod.VocabNodeReadOnly
    ),
  {
    ssr: true,
  }
);
const ImageUploadReadOnly = dynamicEditorComponent(
  () =>
    import(/* webpackExports: "ImageUploadReadOnly" */ './child-node/right-hand-node').then(
      (mod) => mod.ImageUploadReadOnly
    ),
  {
    dependsOn: VocabNodeReadOnly,
  }
);

const LeffHand = dynamicEditorComponent(
  () =>
    import(/* webpackExports: "LeffHand" */ './child-node/left-hand-node').then(
      (mod) => mod.LeffHand
    ),
  {
    ssr: true,
  }
);
const Pronounce = dynamicEditorComponent(
  () =>
    import(/* webpackExports: "Pronounce" */ './child-node/left-hand-node').then(
      (mod) => mod.Pronounce
    ),
  {
    ssr: true,
  }
);
const Word = dynamicEditorComponent(
  () => import(/* webpackExports: "Word" */ './child-node/left-hand-node').then((mod) => mod.Word),
  {
    ssr: true,
  }
);

const Definition = dynamicEditorComponent(
  () =>
    import(/* webpackExports: "Definition" */ './child-node/right-hand-node').then(
      (mod) => mod.Definition
    ),
  {
    dependsOn: VocabNodeReadOnly,
  }
);
const Example = dynamicEditorComponent(
  () =>
    import(/* webpackExports: "Example" */ './child-node/right-hand-node').then(
      (mod) => mod.Example
    ),
  {
    ssr: true,
  }
);

const Right1 = dynamicEditorComponent(
  () =>
    import(/* webpackExports: "Right1" */ './child-node/right-hand-node').then((mod) => mod.Right1),
  { ssr: true }
);

const RightHand = dynamicEditorComponent(
  () =>
    import(/* webpackExports: "RightHand" */ './child-node/right-hand-node').then(
      (mod) => mod.RightHand
    ),
  {
    ssr: true,
  }
);

const Hidden = styled.div`
  display: none;
`;

const isValid = (element) => {
  const [left, right] = element.children;
  const [word, pronouce] = left.children;
  const [right1] = right.children;
  const [defi] = right1.children;
  return (
    word.children[0].text.length > 0 &&
    pronouce.children[0].text.length &&
    defi.children[0].text.length &&
    element?.pType?.length > 0
  );
};

let pType;

export const renderVocabCard = (opt: MediaProps) => (props: RenderElementProps) => {
  const { element } = props;
  const { isPreview } = opt;
  const options = { isPreview: isPreview || element.isPreview };
  switch (element?.type) {
    case MediaType.VOCAB_CARD: {
      if (!isValid(element)) {
        return <Hidden className="invalid-vocab-card" />;
      }
      pType = element?.pType || '';
      return <VocabNodeReadOnly id={element.id as string} {...props} {...options} />;
    }
    case LEFT:
      return <LeffHand {...props} {...options} />;
    case WORD:
      return <Word {...props} {...options} />;
    case PRONOUNCE:
      return <Pronounce {...props} {...options} />;
    case RIGHT:
      return <RightHand {...props} {...options} />;
    case RIGHT1:
      return <Right1 {...props} {...options} />;
    case DEFI:
      return <Definition pType={pType} {...props} {...options} />;
    case EX:
      return <Example {...props} {...options} />;
    case IMG:
      return <ImageUploadReadOnly {...props} {...options} />;
  }
  return null;
};

export const VocabCardReadOnlyPlugin = (props?: MediaProps): SlatePlugin => {
  return {
    renderElement: renderVocabCard(props),
  };
};
